(ns frontend.ux-overhaul.modal.save-view.view
  (:require
   [common.entity :as entity]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [frontend.ui.component.radio-group.view :refer [radio-group]]
   [frontend.ui.component.nested-dropdown.view :as nested-dropdown]
   [ui.components.button.view :as button]
   [ui.color :as c]))

(def example-data
  [{:entity-id   17592186139592
    :permissions :r}])

(def permission-options
  [{:value :r
    :label "View"}
   {:value :rw
    :label "View and edit"}
   {:value :rws
    :label "View, edit and share"}])


(defn save-as-settings
  [state-atom]
  (let [{:keys [view-name view-visibility entities]} @state-atom]
    [:div
     [:div.mb-3
      [:p "View name"]
      [:input
       {:value     view-name
        :on-change (fn [e]
                     (let [value (.. e -target -value)]
                       (swap! state-atom assoc :view-name value)))}]]


     [:div.mb-3
      [:p "Visibility"]
      [radio-group
       {:id        :save-mode
        :checked   view-visibility
        :on-change #(swap! state-atom assoc :view-visibility %)
        :disabled? false}
       {:public     "Everyone"
        :restricted "Select people or teams"
        :private    "Only me"}]]


     (when (= view-visibility :restricted)
       [:div.mb-3
        [:p "Select people or teams you want to give access"]

        [:div.mt-2.mb-2
         [:table
          [:thead
           [:tr
            [:th.pr-4 "Person or team name"]
            [:th "Permissions"]]]

          [:tbody
           (->> entities
                (map-indexed
                 (fn [entity-index entity-permission]
                   (let [{:keys [entity-id permissions]} entity-permission
                         entity (session/get-entity entity-id)
                         entity-type (:entity/type entity)
                         label (entity/display-string entity)]
                     ^{:key (str "acl-row-" entity-index)}
                     [:tr
                      [:td
                       (case entity-type
                         :entity.type/account [:i.fas.fa-user.mr-2]
                         :entity.type/team [:i.fas.fa-users.mr-2]
                         nil)
                       label]
                      [:td
                       [:select
                        {:value     (str permissions)
                         :on-change (fn [e]
                                      (let [value-str (subs (str (.. e -target -value)) 1)
                                            value (keyword value-str)
                                            new-entities
                                            (->> entities
                                                 (map-indexed (fn [index ent]
                                                                (if (= index entity-index)
                                                                  (assoc ent :permissions value)
                                                                  ent))))]
                                        (swap! state-atom assoc :entities new-entities)))}
                        (->> permission-options
                             (map (fn [{:keys [label value]}]
                                    [:option
                                     {:value (str value)}
                                     label])))]]
                      [:td
                       [:button.ml-2
                        {:on-click (fn []
                                     (let [new-entities
                                           (->> entities
                                                (map-indexed (fn [idx e]
                                                               [idx e]))
                                                (filter (fn [[idx e]]
                                                          (not= idx entity-index)))
                                                (mapv second))]
                                       (swap! state-atom assoc :entities new-entities)))}
                        [:i.fal.fa-trash]]]])))
                (doall))]]]

        [nested-dropdown/view
         {:on-select (fn [key]
                       (let [new-entities (vec
                                           (conj entities
                                                 {:entity-id   key
                                                  :permissions :r}))]
                         (swap! state-atom assoc :entities new-entities)))}]

       ])
    ]))

(defn view
  [{:keys [close-modal!]}]
  (let [state (r/atom nil
                      #_{:save-mode       :save-as
                         :view-name       "Example"
                         :view-visibility :restricted
                         :entities        [{:entity-id   17592186060658
                                            :permissions :r}
                                           {:entity-id   17592186139592
                                            :permissions :rw}]
                        })
        on-change #(swap! state assoc :save-mode %)]
    (fn [{:keys [close-modal!]}]
      (let [save-mode (:save-mode @state)]

        [modal-dialog/modal-dialog
         {:visible?     true
          :hide!        close-modal!
          :header-label "Save view"
          :size         :xs
          :style        {:body {:padding "0px"}}}
         [:<>
          [:div
           {:style {:padding    "24px"
                    :min-height "500px"}}

           [:div.mb-3
            [radio-group
             {:id        :save-mode
              :checked   save-mode
              :on-change on-change
              :disabled? false}
             {:save    "Update current view"
              :save-as "Save as a new view to the view library"}]]

           (when (= save-mode :save-as)
             [:div.mb-3
              [save-as-settings state]])

          ]]

         [:div
          {:style {:display         "flex"
                   :width           "100%"
                   :justify-content "end"}}
          [button/secondary-hollow
           {:on-click close-modal!}
           "Cancel"]
          [button/primary-solid
           {}
           "Save"]]]))))
